
import React, { useState, useEffect, useCallback } from 'react';
import style from '../Home/View/PayWayView/PayWayView.scss'
import { List, Radio, Button, Toast, Icon } from 'antd-mobile'
import { Spin } from 'antd'
import { api } from '../../common/app';
import { useHistory } from 'react-router-dom'
import { ComponentFormItem, FormItmeType } from '../../components/form';
import moment from 'moment';
import invariant from 'invariant';
import wx from 'weixin-jsapi';
import imgfree from '../../assets/free.png';
import Modal from './component/modal'
import Empty from '../Mine/component/empty';

const { RadioItem } = Radio;

let timer: any;

export default (props: any) => {
  const { id } = props.match.params;
  const history = useHistory();
  const [payway, setPayway] = useState('wechat');
  const [payData, setPayData] = useState({} as any);
  const [payPickerData, setPayPickerData] = useState([] as any[]);
  const [selectedPeople, setSelectedPeople] = useState('');

  const [peopleAndTimeParams, setPeopleAndTimeParams] = useState({} as any);
  const [nativePayload, setNativePayload] = useState({} as any);

  const [visible, setVisible] = useState(false);
  const [nativeResult, setNativeResult] = useState({} as any);
  const [showResult, setShowResult] = useState(false);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    if (id) {
      setLoading(true);
      (api as any).getPayData({ meetid: id })
        .then((result: any) => {
          console.log('result', result);
          setPayData(result.result);
          setShowResult(result.result?.is_pay === true);

          setTimeout(() => {
            setLoading(false)
          }, 500);
        })
        .catch((error: any) => {
          Toast.fail(error.message);
        })
    }
  }, [id]);

  useEffect(() => {
    if (payData.pay_type === 3) {

      if (payData.pay_data) {
        const pickerData = payData.pay_data.map((item: any) => {
          return {
            label: item.people,
            value: item.people_id,
          }
        })
        console.log('pickerData', pickerData);
        setPayPickerData(pickerData);
      }
    }
    if (payData.pay_type === 5) {
      // 先计算时间
      let selectedItem: any;
      payData.pay_data.forEach((item: any) => {
        const isBetween = moment().isBetween(item.start_time * 1000, item.end_time === 0 ? 999999999 : item.end_time * 1000);
        console.log('isBetween', isBetween);
        if (isBetween === true) {
          selectedItem = item;
        }
      });
      console.log('selectedItem', selectedItem);
      // 存入state

      if (selectedItem.people_params) {
        setPeopleAndTimeParams(selectedItem);
        const pickerData = selectedItem.people_params.map((people: any) => {
          return {
            label: people.people_type,
            value: people.people_id
          }
        });
        console.log('pickerData', pickerData);
        setPayPickerData(pickerData);
      }
    }
  }, [payData])

  useEffect(() => {
    if (visible === false) {
      clearInterval(timer);
      timer = undefined;
    }

    if (visible === true) {
      console.log('timer', timer);
      if (!timer) {
        timer = setInterval(() => {
          checkStatus(nativeResult);
        }, 2000);
      }
    }

    return () => clearInterval(timer);
  }, [visible, nativeResult]);

  const checkStatus = (payload: any) => {
    try {
      console.log('nativeResult', payload);
      // return;
      (api as any).orderQuery({ orderno: payload.orderno })
        .then((result: any) => {
          if (result.result.status === true) {
            setVisible(false);
            clearInterval(timer);
            setShowResult(true);
          }
        })
    } catch (error) {
      Toast.fail(error.message);
    }
  }

  const onNativeHandle = (payload?: any) => {
    console.log('payload', payload || nativePayload);

    const params = {
      ...payload || nativePayload
    };
    console.log('params', params);
    (api as any).native(params)
      .then((result: any) => {
        console.log('result', result);
        setNativeResult(result.result);
        setVisible(true);
      });
  }

  const onPayHandle = (type?: string) => {
    try {
      let payload: any = {
        meetid: id,
        pay_type: payData.pay_type,
      };
      if (payData.pay_type === 1) {
        history.push(`/home/index/${id}`);
        return;
      }
      if (payData.pay_type === 2) {
        payload.fee = payData?.pay_data?.fee;
        payload.people_id = 0;
      }
      if (payData.pay_type === 3) {
        invariant(!!selectedPeople, '请先选择您的身份');
        const selectedItem = payData.pay_data.find((i: any) => i.people_id === selectedPeople);
        payload.fee = selectedItem.fee;
        payload.people_id = selectedItem.people_id;
      }
      if (payData.pay_type === 4) {
        let selectedItem: any = {};
        payData.pay_data.forEach((item: any) => {
          const isBetween = moment().isBetween(item.start_time * 1000, item.end_time === 0 ? 999999999 : item.end_time * 1000);
          console.log('isBetween', isBetween);
          if (isBetween === true) {
            selectedItem = item;
          }
        });
        payload.fee = selectedItem.fee;
        payload.people_id = 0;
      }
      if (payData.pay_type === 5) {
        invariant(!!selectedPeople, "请先选择您的身份");
        const selectedItem = peopleAndTimeParams.people_params.find((i: any) => i.people_id === selectedPeople);
        payload.fee = selectedItem?.fee;
        payload.people_id = selectedItem.people_id;
      }
      if (type === 'native') {
        setNativePayload(payload);
        onNativeHandle(payload);
        return;
      }

      (api as any).jsapi(payload)
        .then((res: any) => {
          wx.chooseWXPay({
            timestamp:res.result.jsApiParams.timeStamp,
            appId:res.result.jsApiParams.appId,
            nonceStr:res.result.jsApiParams.nonceStr,
            package:res.result.jsApiParams.package,
            paySign:res.result.jsApiParams.paySign,
            signType:"MD5",
            success: function (res: any) {
              // 支付成功后的回调函数
              setShowResult(true);
            },
            cancel: function (res: any) {
              console.log('cancel:', res);
            },
            fail: function (res: any) {
              Toast.fail("支付失败");
              console.log(res,6666);
            }
          });
        })
        .catch((error: any) => {
          Toast.fail(error.message);
        })
    } catch (error) {
      Toast.fail(error.message);
    }
  }

  const renderNumber = () => {
    // 免费
    if (payData.pay_type === 1) {
      return '0.00'
    }
    // 固定
    if (payData.pay_type === 2) {
      return payData?.pay_data?.fee || '0.00';
    }
    // 按人群
    if (payData.pay_type === 3) {
      const selectedItem = payData.pay_data.find((i: any) => i.people_id === selectedPeople);
      return selectedItem ? selectedItem.fee : '0.00';
    }
    // 按时间
    if (payData.pay_type === 4) {
      let selectedItem: any = {};
      payData.pay_data.forEach((item: any) => {
        const isBetween = moment().isBetween(item.start_time * 1000, item.end_time === 0 ? 999999999 : item.end_time * 1000);
        console.log('isBetween', isBetween);
        if (isBetween === true) {
          selectedItem = item;
        }
      });
      return selectedItem.fee;
    }
    // 按时间和人群
    if (payData.pay_type === 5) {
      if (peopleAndTimeParams.people_params) {
        const selectedItem = peopleAndTimeParams.people_params.find((i: any) => i.people_id === selectedPeople);
        return selectedItem?.fee || '0.00';
      }
      return '0.00'
    }
    return '0.00';
  }
  if (payData.pay_type === 1) {
    return (
      <div style={{marginTop: '20vh'}}>
        <Empty
          imgClick={() => { history.replace(`/mine/index/${id}`) }}
          title='当前会议为免费'
          style={{
            width: 262 / 1.5,
            height: 123 / 1.5
          }}
          img={imgfree}
          customRender={() => {
            return (
              <div className={style.OtherButton} style={{ width: '30%', marginTop: '14vh' }} onClick={() => { history.replace(`/mine/index/${id}`) }}>返回</div>
            )
          }}
        />
      </div>
    )
  }

  return (
    <div style={{ height: '100%' }}>
      <Spin spinning={loading} style={{minHeight: 400}}>
        {loading === false && (
          <div className={[style.PayWayView, 'childcenter childcontentstart childcolumn'].join(' ')}>
          <div className={[style.ViewTitle, 'childcenter childalignstart childcolumn'].join(' ')}>
            <div className={[style.NameValue].join(' ')}>
              费用缴纳
          </div>
            {!showResult ? (
              <div style={{ width: '100%' }}>
                {payData.pay_type === 3 && (
                  <div style={{ width: '100%', backgroundColor: '#fff', marginBottom: 12 }}>
                    <ComponentFormItem
                      cols={1}
                      style={{ margin: 0 }}
                      formType={FormItmeType.Picker}
                      data={payPickerData}
                      value={[selectedPeople]}
                      onOk={(params) => {
                        setSelectedPeople(params[0])
                      }}
                    />
                  </div>
                )}
                {payData.pay_type === 5 && (
                  <div style={{ width: '100%', backgroundColor: '#fff', marginBottom: 12 }}>
                    <ComponentFormItem
                      cols={1}
                      style={{ margin: 0 }}
                      formType={FormItmeType.Picker}
                      data={payPickerData}
                      value={[selectedPeople]}
                      onOk={(params) => setSelectedPeople(params[0])}
                    />
                  </div>
                )}
                <div className={[style.Card].join('')}>
                  <span style={{ fontWeight: 'bold' }}>
                    <em style={{ fontStyle: 'normal' }}>￥</em>
                    <span style={{ fontSize: 30, marginLeft: 5 }}>{renderNumber()}</span>
                  </span>
                  <span style={{ fontSize: 12, color: 'gray' }}>应付费用</span>
                </div>
              </div>
            ) : (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '18vh' }}>
                  <Icon style={{ width: 50, height: 50, color: '#04BE02' }} type='check-circle' />
                  <span style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 20, marginTop: 20 }}>支付成功</span>
                  <div className={style.OtherButton} style={{ width: '30%', marginTop: '14vh' }} onClick={() => { history.replace(`/mine/index/${id}`) }}>返回</div>
                </div>
              )}
          </div>
          </div>
        )}
       
        {loading === false && !showResult && (
          <div>
            <List style={{ marginTop: 30 }}>
              <List.Item>
                <div style={{ padding: '10px 0', fontSize: 18, fontWeight: 'bold' }}>
                  付款方式
                </div>
              </List.Item>
              <RadioItem checked={payway === 'wechat'} onChange={() => setPayway('wechat')}>
                微信支付
              </RadioItem>
            </List>

            <div style={{ padding: '0 24px', marginTop: 40 }}>
              <Button type='primary' onClick={() => onPayHandle()}>确认支付 </Button>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 20 }}>
                <div className={style.OtherButton} onClick={() => onPayHandle('native')}>找他人代付</div>
                <div className={style.OtherButton} onClick={() => { history.replace(`/mine/index/${id}`) }}>暂不缴费下次再说</div>
              </div>
            </div>
          </div>
        )}
      </Spin>

      <Modal
        visible={visible}
        onClose={() => setVisible(false)}
        data={nativeResult}
        refresh={onNativeHandle}
      />
    </div>
  )
}